// extracted by mini-css-extract-plugin
export var externalLink = "_85-0";
export var internalLinkLabel = "_85-1";